import './Auth.css';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import google from '../../Assets/Images/RegisterPage/social.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  MobileRegister } from '../../services/AuthWithMobile.jsx';


function OtpRegister(){

    const navigate=useNavigate();

    const [mobile,setMobileNumber]=useState();

    const [error,setError]=useState();

    const validateMobileNumber = (number) => {
        
        const regex = /^[0-9]{10}$/; 
        if (!regex.test(number)) {
            setError("Please enter 10 digit mobile number");
          } else {
            setError(''); 
          }
      };

    async function HandleSubmit(e){
        e.preventDefault()
        validateMobileNumber(mobile);
        const registerWithMobile=await MobileRegister(mobile);

        if(registerWithMobile && registerWithMobile.sid && !error)
        {
            navigate('/otpverify',{ state: { phoneNumber:registerWithMobile.sid.to,'flow':'register' }})
        }
        else
        {
            setError(registerWithMobile);
        }
    }  
    return(
        <>
             <div className='logincontainer'>
                    <form className='loginform' onSubmit={(e)=>HandleSubmit(e)}>
                           <h2>Enter your phone number</h2>
                           <h3> We will send you the 4 digit verification code</h3>
                           <section className='logininput'>
                           <input type='text' name='mobilenumber' placeholder='+91 9058585874' onChange={(e)=>setMobileNumber(e.target.value)}/>
                           </section>
                           <section className='loginbuttons'>
                            <label className='mobileerror' style={{marginBottom:'5px',color:'var(--border-color)'}}>{error}</label>
                                <button className='loginbutton' onClick={()=>validateMobileNumber(mobile)}>GENERATE OTP</button>
                                <div className='orsection'>
                                    <hr  class="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  class="custom-hr"/>
                                </div>
                            </section>
                    </form>
                    <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} alt='linkedIn' width="38" height="38"/>
                            </section>
                            <h4> New User? <span  onClick={()=>window.location.href="/register"}>Register here</span></h4>
             </div>
        </>
        );

}

export default OtpRegister;